import React, {PureComponent} from 'react';

import PropTypes from 'prop-types';

import './DoubleButton.less';

class DoubleButton extends PureComponent {
  isButton1Disabled = () => {
    const {button1Props} = this.props;
    if (button1Props.disabled) return true;
    return false;
  };

  handleButton1Press = () => {
    const {button1Props} = this.props;
    if (this.isButton1Disabled() === false) button1Props.startLongPress();
  };

  handleButton1Release = () => {
    const {button1Props} = this.props;
    if (this.isButton1Disabled() === false) button1Props.endLongPress();
  };

  // eslint-disable-next-line class-methods-use-this
  contextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  render() {
    const {button1Props, button2Props} = this.props;
    return (
      <div className="div-2col50">
        <button
          type="button"
          onClick={button1Props.onClick}
          id={button1Props.id}
          className={`${button1Props.className} center`}
          disabled={button1Props.disabled}
          onPointerDown={button1Props.enableLongPress ? this.handleButton1Press : undefined}
          onPointerUp={button1Props.enableLongPress ? this.handleButton1Release : undefined}
          onPointerLeave={button1Props.enableLongPress ? this.handleButton1Release : undefined}
          onContextMenu={this.contextMenu}
        >
          <span
            className="text-button center"
            id={button1Props.id}
          >
            {button1Props.label}
          </span>
        </button>
        <button
          type="button"
          onClick={button2Props.onClick}
          id={button2Props.id}
          className={`${button2Props.className} center doubleButton`}
          disabled={button2Props.disabled}
          onContextMenu={this.contextMenu}
        >
          <span
            className="text-button center"
            id={button2Props.id}
          >
            {button2Props.label}
          </span>
        </button>
      </div>
    );
  }
}

DoubleButton.propTypes = {
  button1Props: PropTypes.object,
  button2Props: PropTypes.object,
};

DoubleButton.defaultProps = {
  button1Props: {},
  button2Props: {},
};

export default DoubleButton;
